import { render, staticRenderFns } from "./IntegrationTable.vue?vue&type=template&id=08b0150d&scoped=true&"
import script from "./IntegrationTable.vue?vue&type=script&lang=js&"
export * from "./IntegrationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0150d",
  null
  
)

export default component.exports